import React from "react";
import { Helmet } from "react-helmet-async";

function Seo({
  title,
  description,
  canonical,
  robots,
  og = {},
  twitter = {},
  jsonLd,
}) {
  const resolvedTitle = title || "First 1000";
  const resolvedDescription = description || "";
  const resolvedCanonical = canonical || "";

  if (resolvedCanonical) {
    og = { type: 'website', siteName: 'First 1000', url: resolvedCanonical, title: resolvedTitle, description: resolvedDescription, image: 'https://www.first1000.co/first1000-social.png', ...og };
    twitter = { card: 'summary_large_image', title: resolvedTitle, description: resolvedDescription, image: og.image, ...twitter };
  }
  return (
    <Helmet>
      {resolvedTitle ? <title>{resolvedTitle}</title> : null}
      {resolvedDescription ? (
        <meta name="description" content={resolvedDescription} />
      ) : null}
      {resolvedCanonical ? <link rel="canonical" href={resolvedCanonical} /> : null}
      {robots ? <meta name="robots" content={robots} /> : null}

      {og.type ? <meta property="og:type" content={og.type} /> : null}
      {og.siteName ? <meta property="og:site_name" content={og.siteName} /> : null}
      {og.url ? <meta property="og:url" content={og.url} /> : null}
      {og.title ? <meta property="og:title" content={og.title} /> : null}
      {og.description ? (
        <meta property="og:description" content={og.description} />
      ) : null}
      {og.image ? <meta property="og:image" content={og.image} /> : null}
      {og.imageAlt ? (
        <meta property="og:image:alt" content={og.imageAlt} />
      ) : null}

      {twitter.card ? <meta name="twitter:card" content={twitter.card} /> : null}
      {twitter.title ? (
        <meta name="twitter:title" content={twitter.title} />
      ) : null}
      {twitter.description ? (
        <meta name="twitter:description" content={twitter.description} />
      ) : null}
      {twitter.image ? (
        <meta name="twitter:image" content={twitter.image} />
      ) : null}

      {jsonLd ? (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      ) : null}
    </Helmet>
  );
}

export default Seo;
